module.exports = __webpack_public_path__ + "img/visa.d15d4998.svg";